import { render, staticRenderFns } from "./update-user-role.vue?vue&type=template&id=d2bd97fc&scoped=true"
import script from "./update-user-role.vue?vue&type=script&lang=js"
export * from "./update-user-role.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bd97fc",
  null
  
)

export default component.exports